import * as yup from "yup";

export default () => yup.object().shape({
  name: yup.string().trim()
    .max(1000, "text_too_long"),
});
